import {createContext} from 'react';

export const CamerasContext = createContext([]);
export const TagsContext = createContext([]);
export const PlaylistsContext = createContext([]);
export const BannersContext = createContext([]);
export const CurrentCameraContext = createContext([]);
export const PrivatePageContext = createContext({});
export const ModalWindowStateContext = createContext([]);
